import React, { memo } from 'react'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { useTranslation, Trans } from 'react-i18next'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'

import generalStyles from '../../styles'
import styles from './styles'
import { combineStyles } from 'utils'
import studentsKitLanding from 'assets/images/studentsKitLanding.jpg'

const combinedStyles: any = combineStyles(generalStyles, styles)
const useStyles = makeStyles(combinedStyles)

const RegisterForm: React.FunctionComponent<any> = () => {
	const { i18n } = useTranslation()
	const t = i18n.getFixedT('ro')
	const theme: Theme = useTheme()
	const isSmDown = useMediaQuery(theme.breakpoints.down('sm'))
	const classes = useStyles()
	return (
		<Paper classes={{ root: classes.paper }}>
			<Grid container>
				<Grid item xs={12}>
					<div className={classes.headerTitle}>
						{!isSmDown ? (
							<div>
								{t('Inregistreaza-te la Students Kit 2023')}
							</div>
						) : (
							<Trans key={'registerToStudentsKit2023'}>
								Inregistreaza-te la
								<br />
								Students Kit 2023
							</Trans>
						)}
					</div>
					<img
						alt="company_team"
						className={classes.image}
						src={studentsKitLanding}
					/>
				</Grid>
				{/* <Grid item xs={12} classes={{ root: classes.gridItemButton }}>
					<Button
						classes={{ root: classes.button }}
						size="small"
						variant={'contained'}
						color={'primary'}
					>
						{t('Go To Register')}
					</Button>
				</Grid> */}
				{/* <Grid item xs={12} classes={{ root: classes.gridItemButton }}>
					<Button
						size="small"
						variant={'contained'}
						color={'secondary'}
					>
						{t('Go To Resend Code')}
					</Button>
				</Grid> */}
			</Grid>
		</Paper>
	)
}

export default memo(RegisterForm)
